import type { OrderSummary } from '#domain/Order.ts';

export type OrderOption = {
    id: string;
    label: string;
    selected: boolean;
};

export const getOrderOptions = (relatedOrders: OrderSummary[], selectedOrderIds: string[]): OrderOption[] =>
    relatedOrders.map(order => ({
        id: order.id,
        label: order.number,
        selected: selectedOrderIds.includes(order.id),
    }));
